export const BASE_URL = "https://healthy-hub-students.b.goit.study";
// export const BASE_URL = "http://localhost:4040";